import { render, staticRenderFns } from "./Rdwgc.vue?vue&type=template&id=5f8c8180&scoped=true&"
import script from "./Rdwgc.vue?vue&type=script&lang=js&"
export * from "./Rdwgc.vue?vue&type=script&lang=js&"
import style0 from "./Rdwgc.vue?vue&type=style&index=0&id=5f8c8180&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8c8180",
  null
  
)

export default component.exports